import { createGlobalStyle } from "styled-components";

export const DashboardCss = createGlobalStyle`
    .parent-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        /* align-items: center; */
        padding: 20px;
        gap: 20px;
    }
    .chart-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 7px;
        padding: 2%;
        border: 2px solid #ffff;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 5px;
    }
    .leaderborad-table {
        width: 72%;
        height: 68vh;
    }
    .chart-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 7px;
    }
    .chart-content-head {
        font-weight: bolder;
        color: #8884d8;
    }
    .chart-content-body {
        font-weight: normal;
        color: #8884d8;
    }
    .avatar {
        vertical-align: middle;
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }
    .top3-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 10px;
    }
    .firstCard {
        padding: 1%;
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
        border-bottom: 60px solid #C9A866;
    }
    .firstCard .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .secondCard {
        padding: 1%;
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
        border-bottom: 45px solid #939395;
    }
    .secondCard .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .thirdCard {
        padding: 1%;
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
        border-bottom: 35px solid #AE622A;
    }
    .thirdCard .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .rank {
        font-weight: bold;
        font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
    }
`;
